var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('navgate'),_c('div',{staticClass:"web_box"},[_c('div',{staticClass:"web_content newsAll"},[_c('ImageTitleListView',{attrs:{"titleName":"全部新闻","messageList":_vm.newsList.list,"perPage":_vm.perPage,"detailRouter":"newsDetail"}})],1)]),_c('footer-build')],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }